import { Controller } from '@hotwired/stimulus';

const STORAGE_KEY_PREFIX = 'article-announcement-topbar:dismissed:';

export default class extends Controller {
  static targets = ['iframe'];
  static values = {
    url: { type: String, default: '' },
    campaign: { type: String, default: '' },
  };

  connect() {
    if (this.urlValue.length === 0 || this.#isDismissed()) {
      this.#hide();
      return;
    }

    this.element.hidden = null;
    this.iframeTarget.src = this.urlValue;
    this.iframeTarget.allowTransparency = true;
    this.iframeTarget.frameBorder = 0;
  }

  dismiss() {
    try {
      localStorage.setItem(this.#storageKey(), 'true');
    } catch {
      // Ignore storage errors (e.g. private browsing quota)
    }
    this.#hide();
  }

  #hide() {
    this.element.hidden = true;
    if (this.hasIframeTarget) {
      this.iframeTarget.src = '';
    }
  }

  #isDismissed() {
    try {
      return localStorage.getItem(this.#storageKey()) === 'true';
    } catch {
      return false;
    }
  }

  #storageKey() {
    return `${STORAGE_KEY_PREFIX}${this.campaignValue}`;
  }
}
